export const copy = (id, value) => {
  const el = document.createElement("textarea");
  el.value = value;
  document.getElementById(id).appendChild(el);
  el.select();
  document.execCommand("copy");
  document.getElementById(id).removeChild(el);
};